import generic from './generic';
import nav from './nav';
import player from './player';
import editor from './editor';
import onboard from './onboard';
import home from './home';
import search from './search';
import message from './message';
import config from './config';
import hub from './hub';
import dashboard from './dashboard';
import learners from './learners';
import learnerGroup from './learner-group';
export default {
  generic,
  nav,
  dashboard,
  player,
  editor,
  onboard,
  home,
  message,
  config,
  hub,
  search,
  learners,
  learnerGroup
};
